import React from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { EMobilityWallboxPricesModel } from './models/e-mobility-wallbox-models'
import WallboxPrices from './WallboxPrices'

const useStyles = makeStyles()(theme => ({
  priceContainer: {
    padding: theme.spacing(2),
  },
}))

interface WallboxPriceInfoProps {
  prices: EMobilityWallboxPricesModel[] | undefined
  isLoading: boolean
  isError: boolean
  energyDirection: 'charge' | 'discharge'
  isDynamicPrice?: boolean
}

/**
 * Component for displaying price values inside single wallbox card.
 * It displays prices for charge or discharge value
 * @param price price as EMobilityWallboxPricesModel or undefined
 * @param isLoading boolean for loading price state
 * @param isError boolean for error price state
 * @param energyDirection corresponds to charge or discharge direction
 * @return JSX element
 */
const WallboxPriceInfo: React.VFC<WallboxPriceInfoProps> = ({ prices, isLoading, isError, energyDirection, isDynamicPrice = false }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const isChargeDirection = energyDirection === 'charge'

  return (
    <>
      {isError && (
        <Stack className={classes.priceContainer}>
          <Typography color={'error'}>
            {isChargeDirection ? t('emobility.wallbox.chargePriceFailedToFetch') : t('emobility.wallbox.dischargePriceFailedToFetch')}
          </Typography>
        </Stack>
      )}

      {!isError && (
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} flexWrap={'wrap'} className={classes.priceContainer}>
          <Typography>{isChargeDirection ? t('emobility.wallbox.chargePricePerKwh') : t('emobility.wallbox.dischargePricePerKwh')}</Typography>
          {isLoading ? <CircularProgress size={16} /> : <WallboxPrices isDynamicPrice={isDynamicPrice} prices={prices} />}
        </Stack>
      )}
    </>
  )
}

export default WallboxPriceInfo
